import { render, staticRenderFns } from "./DiscountRuleBase.vue?vue&type=template&id=c6b7cea8&"
import script from "./DiscountRuleBase.vue?vue&type=script&lang=js&"
export * from "./DiscountRuleBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports